import { DateTime as luxon } from 'luxon';
import useSettingsStore from '@/store/settings.ts';
import { DATE_FORMAT } from '@/const';

interface DateTimeProps {
    format?: string;
    value: string;
}

const DateTime = ({ value, format = DATE_FORMAT.FULL_12H }: DateTimeProps) => {
    const timeZone = useSettingsStore((state) => state.settings.timeZone);
    const isUTC = useSettingsStore((state) => state.settings.isUTC);
    if (!value) {
        return value;
    }
    const datetime = value.endsWith('Z') ? value : `${value}Z`;
    if (isUTC) {
        return luxon.fromISO(datetime).toUTC().toFormat(format);
    }
    return luxon.fromISO(datetime).setZone(timeZone).toFormat(format);
};

export default DateTime;
